import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { Box, Typography, Link } from "@mui/material";

const SHEET_URL =
  "https://docs.google.com/spreadsheets/d/1bk6gcZwTGt6NrmDrut2tLllta6SAtLaQQIhbI8Y3SJU/gviz/tq?tqx=out:json";

export default function NewsTicker() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetch(SHEET_URL)
      .then((res) => res.text())
      .then((text) => {
        const json = JSON.parse(text.substring(47).slice(0, -2));
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const rows = json.table.rows
          .slice(1) // skip header row
          .map((r) => ({
            type: r.c[0]?.v || "info",
            message: r.c[1]?.v?.trim() || "",
            link: r.c[2]?.v?.trim() || null,
            startDate: r.c[3]?.v ? new Date(r.c[3].v) : null,
            endDate: r.c[4]?.v ? new Date(r.c[4].v) : null,
          }))
          .filter((item) => {
            if (!item.message) return false;
            if (item.startDate && today < item.startDate) return false;
            if (item.endDate && today > item.endDate) return false;
            return true;
          });

        setItems(rows);
      });
  }, []);

  if (!items.length) return null;

  // Add an initial empty spacer item to visually center the start
  const marqueeItems = [<span key="spacer" style={{ marginRight: "90%" }} />].concat(
    items.map((item, index) => (
      <Box
        key={index}
        sx={{
          mx: 8,
          display: "flex",
          alignItems: "baseline",
          gap: 1,
        }}
      >
        <Typography
          variant="body1"
          sx={{
            fontWeight: 600,
            fontSize: "1.1rem",
            fontFamily: "Roboto, sans-serif",
            color: item.type === "alert" ? "#c62828" : "text.primary",
            display: "flex",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          {item.message}
        </Typography>

        {item.link && (
          <Link
            href={item.link}
            underline="hover"
            sx={{ fontSize: "1.1rem", lineHeight: 1.4, fontFamily: "Roboto, sans-serif", }}
            
          >
            More
          </Link>
        )}
      </Box>
    ))
  );

  return (
    <Box
      sx={{
        backgroundColor: "#FFF9C4", // chill pastel yellow
        borderBottom: "1px solid #e0e0e0",
        py: 1.5,
      }}
    >
      <Marquee pauseOnHover speed={35} gradient={false} loop={0} gap={0}>
        {marqueeItems}
      </Marquee>
    </Box>
  );
}
